import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { IconButton } from '@atlaskit/button/new';
import LockIcon from '@atlaskit/icon/core/migration/lock-locked--lock-filled';
import UnlockIcon from '@atlaskit/icon/core/migration/lock-unlocked--unlock';
import { token } from '@atlaskit/tokens';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { Props } from './types.tsx';

export const Loading = (props: Props) => {
	const { initialValue } = props;
	const Icon = initialValue ? LockIcon : UnlockIcon;
	const loadingIcon = useCallback(
		() => <Icon color={token('color.icon.disabled')} label="" />,
		[Icon],
	);

	return isVisualRefreshEnabled() ? (
		<IconButton
			appearance="default"
			spacing="default"
			isDisabled
			aria-hidden
			icon={loadingIcon}
			label=""
			interactionName="auto-generated.jira-issue-field-security-level.ui.loading.button"
		/>
	) : (
		<Button
			appearance="subtle"
			spacing="default"
			isDisabled
			aria-hidden
			iconBefore={
				<LoadingButtonContent>
					<Icon color="currentColor" label="" />
				</LoadingButtonContent>
			}
			interactionName="auto-generated.jira-issue-field-security-level.ui.loading.button"
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const LoadingButtonContent = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.icon.disabled'),
	display: 'flex',
	alignItems: 'center',
});
